import type {
  CheckoutThemedText,
  OffersPageThemedText,
  ThemedText,
} from '@trmediaab/zebra';

const text: ThemedText & CheckoutThemedText & OffersPageThemedText = {
  root: {
    variants: {
      default: {
        fontSize: [1, null, 2],
        fontFamily: 'primary',
        fontWeight: 'base',
        lineHeight: 'base',
        color: 'text.primary',
      },
    },
  },
  p: {
    variants: {
      offersPageHeader: {
        fontFamily: 'decorative',
        fontSize: [2, null, 6],
        color: 'darkerRed',
        textDecoration: 'underline',
        mt: '2,5',
      },
      landingPagesPreamble: {
        fontSize: [3, null, 4],
      },
    },
  },
  em: {
    variants: {
      default: {
        fontStyle: 'italic',
      },
    },
  },
  strong: {
    variants: {
      default: {
        fontWeight: 'bold',
      },
    },
  },
  small: {
    variants: {
      default: {
        fontSize: [0, null, 1],
        lineHeight: 'medium',
      },
    },
  },
};

export default text;
